import { faRectangleVerticalHistory } from "@fortawesome/pro-regular-svg-icons/faRectangleVerticalHistory";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card, CardContent, IconButton, useTheme } from '@mui/material';
import { MprcContainer, MprcInfiniteLoading, MprcRequestErrorReport, MprcRequestIndicator } from 'components';
import { useWindowSize } from 'hooks/useWindowSize';
import React, { useMemo, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router';
import { RegistrationNoticeView } from 'views/lms/student/Registration/components/RegistrationNoticeView';
import { RegistrationViewHeader } from 'views/lms/student/Registration/components/RegistrationViewHeader';
import { useTrainingRegistrationContext } from "views/lms/student/Registration/TrainingRegistrationDialog";
import { TrainingViewBar } from 'views/lms/student/TrainingView/TrainingViewBar';
import { TrainingViewContainer } from 'views/lms/student/TrainingView/TrainingViewContainer';
import { TrainingViewRightPanel } from 'views/lms/student/TrainingView/TrainingViewRightPanel';

///////////////////////////////////////////////////////////////////////////////

export const InternalTrainingRegistrationPage = () => {

    const {
        setTraining,
        viewError,
        loading, saving, creatingEnroll,
        ActionButton,
        currentTab,
        training, classrooms, selectedClassroom, registerSubordinates, checks, classroomId, Content } = useTrainingRegistrationContext();

    const { t } = useTranslation("lms");
    const theme = useTheme();
    const navigate = useNavigate();
    const { width } = useWindowSize({ wait: 50 });

    const [openRightPanel, setOpenRightPanel] = useState<boolean>(false);

    const headerActions = useMemo(() => {
        var headerItems: React.ReactNode[] = [];

        if (width < theme.breakpoints.values["md"])
            headerItems.push([<IconButton key="back" onClick={() => setOpenRightPanel(state => !state)}><FontAwesomeIcon icon={faRectangleVerticalHistory} /></IconButton>]);

        return headerItems;

    }, [width]);

    return <MprcContainer>
        <MprcContainer position="sticky" margin="none">
            <TrainingViewBar
                onClose={() => navigate(-1)}
                actions={headerActions}
            />
            <MprcInfiniteLoading visible={loading} />
        </MprcContainer>

        {viewError &&
            <MprcContainer>
                <MprcRequestErrorReport error={viewError} />
            </MprcContainer>
        }

        <MprcRequestIndicator visible={creatingEnroll} type="post" message={t("Registration.Training.CreatingEnrollText")} />

        <MprcRequestIndicator visible={saving || loading} type={saving ? "post" : "request"} />

        {
            training &&
            <MprcContainer>
                <TrainingViewContainer
                    openRightPanel={openRightPanel}
                    onCloseRighPanel={() => setOpenRightPanel(false)}
                    content={
                        <>
                            <MprcContainer>
                                <Card>
                                    <CardContent>
                                        {(classrooms.length <= 1 || currentTab != 0) &&
                                            <RegistrationNoticeView
                                                training={training}
                                                classrooms={classrooms}
                                                selectedClassroom={selectedClassroom}
                                                readonly={false}
                                                registerSubordinates={registerSubordinates}
                                                registrationChecks={checks}
                                            />
                                        }

                                        <RegistrationViewHeader
                                            training={training}
                                            classrooms={classrooms}
                                            selectedClassroom={selectedClassroom}
                                            readonly={false}
                                            showClassroomName={classroomId != undefined}
                                            interactionLocation={"bottom"}
                                            actionButton={ActionButton}
                                            onChange={(newData) => setTraining(state => ({ ...state!, ...newData }))}
                                        />
                                    </CardContent>
                                </Card>
                            </MprcContainer>
                            <Card>
                                <CardContent>
                                    {Content}
                                </CardContent>
                            </Card>
                        </>
                    }
                    rightPanel={
                        [<TrainingViewRightPanel key="TrainingViewRightPanel" trainingId={training.trainingId} />]
                    }
                />
            </MprcContainer>
        }
    </MprcContainer>;

};
